<template>
  <div style="height: 100%">
    <video autoplay controls height="100%" muted ref="videoElement" width="100%"></video>
  </div>
</template>

<script>
import flvJs from "flv.js";
import {cameraHeartbeat, getConnectCamera} from "@/network/video";

export default {
  name: "VideoComponent",
  props: {
    properties: {
      type: Object,
      default: () => {
      },
    },
    deviceInfo: {
      type: Object,
      default: () => {
      },
    },
    channel: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      timer: '',
      flvPlayer: null,
      cameraId: null,
    };
  },
  watch: {
    properties() {
      this.getCameraId()
    }
  },
  destroyed() {
    this.destroy()
  },
  mounted() {
    this.getCameraId()
  },
  methods: {
    getCameraId() {
      let cameraRtspEnum = "HAI_KANG_VCR"
      if (this.deviceInfo.brandCnName === '大华') {
        cameraRtspEnum = "DA_HUA"
      }
      if (this.properties) {
        getConnectCamera(cameraRtspEnum, this.properties.User, this.properties.pwd, this.properties.IP, this.channel).then(res => {
          if (res.code === 0) {
            this.cameraId = res.data.cameraId
            setTimeout(this.initFlv, 5000);
          }
        })
      }
    },
    initFlv() {
      if (flvJs.isSupported()) {
        var videoElement = this.$refs.videoElement;
        this.flvPlayer = flvJs.createPlayer({
          type: 'flv',
          isLive: true,
          hasAudio: false,
          url: window.g.httpFlvUrl + this.cameraId
        });
        this.flvPlayer.attachMediaElement(videoElement);
        this.flvPlayer.load();
        this.flvPlayer.play();
        //异常监听
        this.flvPlayer.on(flvJs.Events.ERROR, (errType, errDetail) => {
          this.errorCallback(errType, errDetail)
        });
        //视频播放完毕
        this.flvPlayer.on(flvJs.Events.LOADING_COMPLETE, () => {
        });
        let cameraHeartBeat = {};
        cameraHeartBeat['cameraHeartbeat' + this.cameraId + ':5000'] = this.cameraHeartbeat
        this.$store.dispatch('addIntervalObj', cameraHeartBeat)
      }
    },
    cameraHeartbeat() {
      cameraHeartbeat(this.cameraId).then(res => {
        console.log(res.data);
      })
    },
    errorCallback(errType, errDetail) {
      if (this && !this.isDestroyed) {
        return
      }
      console.log("---ERROR--", errType, errDetail)
      // errType是 NetworkError时，对应errDetail有：Exception、HttpStatusCodeInvalid、ConnectingTimeout、EarlyEof、UnrecoverableEarlyEof
      // errType是 MediaError时，对应errDetail是MediaMSEError
      if (this.timer) {
        clearTimeout(this.timer);
      }
      //网络异常情况
      if (errType === flvJs.ErrorTypes.NETWORK_ERROR && errDetail === flvJs.ErrorDetails.NETWORK_UNRECOVERABLE_EARLY_EOF) {
        this.getCameraId();
      } else {
        this.timer = setTimeout(this.getCameraId, 5000);
      }
    },
    destroy() {
      this.$store.dispatch('removeIntervalObj', 'cameraHeartbeat' + this.cameraId)
      if (this.flvPlayer !== null) {
        this.flvPlayer.pause()
        this.flvPlayer.unload()
        this.flvPlayer.detachMediaElement()
        this.flvPlayer.destroy()
        this.flvPlayer = null
      }
    }
  }
}
</script>

<style scoped>

</style>
